// extracted by css-extract-rspack-plugin
export default {"root":"root-hBEMui","container":"container-bZWImo","tabs":"tabs-QTnBn8","leftSide":"leftSide-aZCqIO"};